import { App } from 'vue'
import svgIcon from '/@/components/svgIcon.vue'

/** Ant Design Vue 组件由 unplugin-vue-components 按需自动注册；此处仅注册项目内全局组件 */
export const antComponents = {
  install (app: App): void {
    app.component('svg-icon', svgIcon)
  },
}
